import { useEffect } from 'react';
import {
  resolveBrand,
  resolveBrandByEmail,
  type BrandConfig,
} from '@/config/branding';
import { useAuth } from '@/routes/AuthContext';

export function useBranding(): BrandConfig {
  const { user } = useAuth();
  const hostnameBrand = resolveBrand();

  let brand: BrandConfig;

  if (hostnameBrand.id !== 'predoc') {
    brand = hostnameBrand;
  } else if (user?.email) {
    brand = resolveBrandByEmail(user.email) ?? hostnameBrand;
  } else {
    brand = hostnameBrand;
  }

  useEffect(() => {
    const link = document.querySelector<HTMLLinkElement>("link[rel='icon']");
    if (link && link.href !== brand.favicon) {
      link.href = brand.favicon;
    }
  }, [brand.favicon]);

  return brand;
}
